import type { Rule, RuleResponse, RuleResult, RulesResponse } from '../../@types/rules';
import { transformRuleResponse } from '../../components/admin/rule/rule-utils';
import { api } from './api';

export const ruleApi = api.enhanceEndpoints({ addTagTypes: ['Rule'] }).injectEndpoints({
  overrideExisting: 'throw',
  endpoints: (builder) => ({
    getRules: builder.query<Array<RuleResult>, number>({
      query: (moduleId) => `/rule/module/${moduleId}/auto-rules`,
      transformResponse: (response: RulesResponse) => {
        return response.result;
      },
    }),
    getRuleById: builder.query<Rule, number>({
      query: (id) => `/rule/auto-rules/simple/${id}`,
      transformResponse: (response: RuleResponse) => transformRuleResponse(response),
      providesTags: (result) => (result ? [{ type: 'Rule' as const, id: result.id as number }] : ['Rule']),
    }),
  }),
});

export const { useGetRulesQuery, useGetRuleByIdQuery, useLazyGetRuleByIdQuery } = ruleApi;
